module.exports = __webpack_public_path__ + "img/2-3.62caf943.png";